import { Button } from '@heroui/react';
import { Edit, Trash2 } from 'lucide-react';
import React, { useState } from 'react';

import { ModalForm } from '../../../../components';
import { useHeroToast } from '../../../../hooks';
import { useUpdateLanguage } from '../../../../queries';
import { LanguageDataDocumentRequest, LanguageDataResponse } from '../../../../types';
import { CreateLanguageForm } from '../../components/CreateLanguageForm';

type ActionRowProps = {
  data: LanguageDataResponse;
  /** Potwierdzenie i samo kasowanie robi strona — single i bulk dzielą jeden modal
   *  i jedną mutację (v3-deleteLanguages). */
  onDelete: (language: LanguageDataResponse) => void;
  isDeleting: boolean;
};

export const ActionRow = ({
  data: initialValue,
  onDelete,
  isDeleting,
}: ActionRowProps): React.JSX.Element => {
  const { showSuccess, showError } = useHeroToast();
  const [showEditLangModal, setShowEditLangModal] = useState<boolean>(false);

  const { mutate: update, isPending: isPendingUpdate } = useUpdateLanguage();

  const handleEditSubmit = async (data: LanguageDataDocumentRequest): Promise<void> => {
    update(
      { id: initialValue.id, data },
      {
        onSuccess: () => {
          showSuccess('Language updated successfully');
          setShowEditLangModal(false);
        },
        onError: (err) => {
          const { message } = (err.response?.data ?? {}) as { message?: string };
          showError(message || 'Language update failed');
        },
      },
    );
  };

  return (
    <>
      <ModalForm
        isLoading={isPendingUpdate}
        form="edit-language-form"
        title="Edit language"
        isOpen={showEditLangModal}
        onClose={() => setShowEditLangModal(false)}
      >
        <CreateLanguageForm
          formId="edit-language-form"
          initialValues={initialValue}
          onSubmit={(e) => handleEditSubmit(e)}
        />
      </ModalForm>

      <div className="flex items-center justify-end gap-[5px] h-[40px]">
        <Button
          isIconOnly
          size="sm"
          variant="light"
          aria-label={`Edit ${initialValue.name}`}
          onPress={() => setShowEditLangModal(!showEditLangModal)}
        >
          <Edit size={14} />
        </Button>
        <Button
          isIconOnly
          size="sm"
          variant="light"
          aria-label={`Delete ${initialValue.name}`}
          isDisabled={isDeleting}
          onPress={() => onDelete(initialValue)}
        >
          <Trash2 size={14} color="red" />
        </Button>
      </div>
    </>
  );
};
